"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBInfoNegative = function SvgBInfoNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M5.882 143.238a5.89 5.89 0 01-5.562-7.787l10.065-29.714A70.811 70.811 0 0146.743 5.63a2.291 2.291 0 011.653 4.275 66.286 66.286 0 00-33.813 93.988c.43.466.649 1.09.602 1.722v.107c-.024.314-.112.62-.26.899L4.649 136.914a1.318 1.318 0 001.668 1.676l18.59-6.308a2.286 2.286 0 011.471 4.328l-18.59 6.308a5.905 5.905 0 01-1.905.32z"
  }), (0, _core.jsx)("path", {
    d: "M62.232 140.952a2.08 2.08 0 01-.312 0 70.095 70.095 0 01-41.821-21.897 2.286 2.286 0 113.352-3.1 65.592 65.592 0 0039.086 20.426 2.29 2.29 0 01-.305 4.571z"
  }), (0, _core.jsx)("path", {
    d: "M65.935 141.326h-.183a68.891 68.891 0 01-28.998-9.044 2.287 2.287 0 012.286-3.962A64.602 64.602 0 0060.137 136a13.79 13.79 0 01-1.691-6.636V46.735a13.905 13.905 0 1127.802 0v82.621a13.92 13.92 0 01-5.905 11.36 2.286 2.286 0 11-2.636-3.733 9.356 9.356 0 003.97-7.62V46.736a9.333 9.333 0 00-18.66 0v82.621a9.326 9.326 0 004.183 7.787 2.286 2.286 0 01-1.265 4.19v-.007z"
  }), (0, _core.jsx)("path", {
    d: "M95.924 137.646a2.286 2.286 0 01-.762-4.435 66.034 66.034 0 0010.667-119.367l-.122-.069a64.503 64.503 0 00-21.09-7.68c3.576 6.564 1.323 14.78-5.1 18.602-6.423 3.822-14.718 1.882-18.781-4.391-4.063-6.274-2.44-14.637 3.675-18.935a2.286 2.286 0 112.637 3.734 9.326 9.326 0 1010.506-.153 2.286 2.286 0 011.44-4.19 68.907 68.907 0 0128.953 9.006l.122.06c23.86 13.718 37.577 40.05 35.143 67.464-2.434 27.416-20.576 50.918-46.48 60.217a2.29 2.29 0 01-.808.137z"
  })));
};

var _default = SvgBInfoNegative;
exports["default"] = _default;